export function translate(text, dict) {
  if (!dict?.length) {
    return text
  }
  return dict.find(({ dictKey }) => String(dictKey) === String(text))?.dictValue ?? text
}
